import React from "react";

// Lended wordmark — clean, modern, single-word brand
export const LogoMark = ({ className = "", size = 36, color = "#0A0A0A", accent = "#FF6B1A" }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Lended"
    >
        {/* Bold L */}
        <path d="M14 12 H24 V44 H46 V54 H14 Z" fill={color} />
        {/* Orange accent bar */}
        <rect x="14" y="8" width="10" height="3" fill={accent} />
        <rect x="50" y="44" width="6" height="10" fill={accent} />
    </svg>
);

export const LogoLockup = ({ className = "", size = 36, dark = false }) => {
    const text = dark ? "#ffffff" : "#0A0A0A";
    return (
        <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
            <LogoMark size={size} color={text} accent="#FF6B1A" />
            <div className="leading-none flex items-baseline">
                <div
                    className="font-display font-extrabold tracking-tight"
                    style={{ color: text, fontSize: size * 0.72, letterSpacing: "-0.045em" }}
                >
                    lended
                </div>
                <div
                    className="font-display font-black"
                    style={{ color: "#FF6B1A", fontSize: size * 0.72, letterSpacing: "-0.045em" }}
                >
                    .
                </div>
            </div>
        </div>
    );
};
